var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Duplicate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ItemPath",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ItemPath-Duplicate",
    transform: "translate(-1335.000000, -210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Duplicate",
    transform: "translate(1335.576923, 210.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8A8A8A",
    x: 0,
    y: 0,
    width: 11.8461538,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.846153846,
    y: 1,
    width: 10.1538462,
    height: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8A8A8A",
    x: 0,
    y: 0,
    width: 11.8461538,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.846153846,
    y: 1,
    width: 10.1538462,
    height: 12
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.d2784cc21f53aab8ac015913ab91cd7f.svg";
export { ForwardRef as ReactComponent };